"use client";

import React, { useEffect, useState } from "react";
import styles from "./Carousel.module.scss";
import For from "@/components/For";
import H2 from "@/components/H2";
import AnimateIn from "@/components/AnimateIn";
import Image from "@/components/Image";
import If from "@/components/If";
import AnimatedBlob from "@/components/Blob";
import Video from "@/components/Video";
import VideoGallery from "@/components/VideoGallery";
import { getVimeoThumbnails } from "@/lib/video";

interface CarouselData {
  images?: any[];
  imagesCollection?: { items: any[] };
  videos?: any[];
  title?: string;
}

const CarouselWithVideos = ({ data = {}, isInterior = false, theme = "default", ...props }: { data?: CarouselData; isInterior?: boolean; theme?: string; [key: string]: any }) => {
  console.log(data)
  return (
    <section
      className={`${styles.carousel} overflow-hidden`}
      {...props}
    >

      <VideoGallery
        videos={data?.videos}
      />

    </section>
  );
};

/**
 * Video Carousel - mimics the image carousel but with videos
 */
const VideoCarousel = ({
  data = {},
  isInterior = false,
  theme = "default",
  ...props
}: { data?: CarouselData; isInterior?: boolean; theme?: string; [key: string]: any }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [thumbnails, setThumbnails] = useState<(string | null)[]>([]);
  const [loading, setLoading] = useState(true);
  const [hasClicked, setHasClicked] = useState(false);

  const videos = data?.videos || [];

  // Fetch thumbnails for all videos
  useEffect(() => {
    const fetchThumbnails = async () => {
      if (videos.length === 0) return;

      setLoading(true);
      const thumbs = await getVimeoThumbnails(videos);
      setThumbnails(thumbs);
      setLoading(false);
    };

    fetchThumbnails();
  }, [videos]);

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
    setHasClicked(true);
  };

  console.log('Have I clicked? ', hasClicked)

  const getURL = (video: string) => {
    const originalURL = video
    if(!hasClicked) {
      return originalURL.includes('autoplay=1') ? originalURL.replace('autoplay=1', 'autoplay=0') : originalURL
    }
    
    return originalURL.includes('autoplay=0') ? originalURL.replace('autoplay=0', 'autoplay=1') : originalURL + '&autoplay=1'
  }

  const originalURL =  videos[activeIndex]?.value
  const videoURL = getURL(originalURL)


  if (loading) {
    return (
      <section
        className={`${styles.carousel} px-gutter stack gap-6 pt-32 relative mb-20 lg:mb-0`}
        {...props}
      >
        <AnimateIn>
          <H2>Testimonials</H2>
        </AnimateIn>
        <div className="flex items-center justify-center h-[400px]">
          <p>Loading videos...</p>
        </div>
      </section>
    );
  }

  return (
    <section
      className={`${styles.carousel} px-gutter stack gap-6 pt-32 relative mb-20 pb-32 lg:mb-0 bg-white z-[1]`}
      {...props}
    >
      <If condition={theme === "assisted-living-landing"}>
        <div className="absolute z-0 top-0 left-0 w-full h-full">
          <AnimatedBlob />
        </div>
      </If>
      <AnimateIn>
        <H2>Testimonials</H2>
      </AnimateIn>
      <div className="flex gap-4 flex-col md:flex-row">
        <AnimateIn as="div" className="md:w-3/4 bg-[#0c2340]">
          <div className="rounded overflow-hidden aspect-[16/9]">
            <iframe
              width="100%"
              height="100%"
              src={`${videoURL}`}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
              title={`Video ${activeIndex + 1}`}
            />
          </div>
        </AnimateIn>
        <AnimateIn
          delay="delay-1"
          as="div"
          className="md:w-1/4 md:grid md:grid-cols-2 flex gap-4 justify-start h-max overflow-x-auto overflow-y-hidden md:overflow-hidden"
        >
          <For
            each={videos}
            render={(video, index) => (
              
                <button
                  key={index}
                  onClick={() => handleThumbnailClick(index)}
                  className={`rounded overflow-hidden  bg-[#0C2340] w-30 md:w-auto aspect-square h-max ${
                    index === activeIndex
                      ? "border-2 border-teal"
                      : "border-2 border-transparent"
                  }`}
                >
                  {thumbnails[index] ? (
                    <Image
                      src={thumbnails[index]!?.replace('_295x166', '')}
                      alt={`Video ${index} thumbnail`}
                      className="md:aspect-[1.05/1]"
                      imgClassName="object-contain"
                      // fillContainer
                      cover={false}
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                      <span className="text-xs text-gray-500">Video {index + 1}</span>
                    </div>
                  )}
                </button>
              
            )}
          />
        </AnimateIn>
      </div>
    </section>
  );
};

/**
 *
 * Carousel
 *
 */
const Carousel = ({
  data = {},
  isInterior = false,
  theme = "default",
  ...props
}: { data?: CarouselData; isInterior?: boolean; theme?: string; [key: string]: any }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };
  // Handle both Contentful (imagesCollection.items) and Sanity (images) data structures
  const thumbnails = data?.imagesCollection?.items || data?.images || [];
  const videos = data?.videos || [];

  if(videos.length > 0) {
    // return <CarouselWithVideos data={data} isInterior={isInterior} theme={theme} {...props} />;
    return <VideoCarousel data={data} isInterior={isInterior} theme={theme} {...props} />;
  }

  return (
    <section
      className={`${styles.carousel} px-gutter stack gap-6 pt-32 relative mb-20 lg:mb-0 bg-white z-[1]`}
      {...props}
    >
      <If condition={theme === "assisted-living-landing"}>
        <div className="absolute z-0 top-0 left-0 w-full h-full">
          <AnimatedBlob />
        </div>
      </If>
      <AnimateIn>
        <H2>Look around</H2>
      </AnimateIn>
      <div className="flex gap-4 flex-col md:flex-row">
        <AnimateIn as="div" className="md:w-3/4">
          <Image
            src={thumbnails?.[activeIndex]?.asset?.url || thumbnails?.[activeIndex]?.url || thumbnails?.[activeIndex] || ""}
            alt="Large Image"
            fillContainer
            imgClassName="rounded overflow-hidden aspect-[978/751]"
            crop={thumbnails?.[activeIndex]?.crop}
            hotspot={thumbnails?.[activeIndex]?.hotspot}
          />
        </AnimateIn>
        <AnimateIn
          delay="delay-1"
          as="div"
          className="md:w-1/4 md:grid md:grid-cols-2 flex gap-4 justify-start h-max overflow-x-auto overflow-y-hidden md:overflow-hidden"
        >
          <For
            each={thumbnails}
            render={(thumbnail, index) => (
              <AnimateIn delay={index % 2 === 0 ? "" : "delay-1"}>
                <button
                  key={index}
                  onClick={() => handleThumbnailClick(index)}
                  className={`rounded overflow-hidden w-30 md:w-auto aspect-square h-max ${
                    index === activeIndex
                      ? "border-2 border-teal"
                      : "border-2 border-transparent"
                  }`}
                >
                  <Image
                    src={thumbnail?.asset?.url || thumbnail?.url || thumbnail}
                    alt={`Thumbnail ${index}`}
                    className="md:aspect-[1.05/1]"
                    imgClassName="md:aspect-[1.05/1]"
                    fillContainer
                    crop={thumbnail?.crop}
                    hotspot={thumbnail?.hotspot}
                  />
                </button>
              </AnimateIn>
            )}
          />
        </AnimateIn>
      </div>
    </section>
  );
};

export default Carousel;
export { VideoCarousel, CarouselWithVideos };
